import { CurrencyDollar as DollarSign, CreditCard, PiggyBank } from "@phosphor-icons/react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Analytics tracking helper
export const trackEvent = async (eventType, data = {}) => {
  try {
    await fetch(`${API_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType, ...data })
    });
  } catch (e) {
    // Silently fail - analytics should not break user experience
  }
};

// TikTok icon
export const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
  </svg>
);

// Threads icon
export const ThreadsIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.334-3.023.678-.562 1.564-.957 2.634-1.175a12.98 12.98 0 01-.81-1.51c-.405-.747-.49-1.58-.242-2.345.362-1.117 1.38-1.987 2.794-2.386.985-.278 2.142-.32 3.347-.12.802.134 1.523.377 2.156.728l-.96 1.772c-.858-.476-1.972-.667-3.047-.522-.917.124-1.81.53-2.105 1.44-.128.396-.085.78.126 1.17.321.593 1.05 1.108 2.058 1.452l.452.135c1.558.093 2.942.397 4.106.906 1.318.576 2.347 1.44 3.06 2.566.782 1.235 1.024 2.71.7 4.263-.348 1.672-1.293 3.148-2.733 4.27-1.602 1.246-3.697 1.932-6.239 2.04z"/>
  </svg>
);

export const PATHS = [
  {
    id: 'stability',
    name: 'Income Stability',
    description: 'Clarity on what you need to earn weekly, including what to set aside for taxes',
    icon: DollarSign,
    color: '#F5CB5C'
  },
  {
    id: 'debt',
    name: 'Pay Off Debt',
    description: 'Finally clear that credit card, loan, or bill',
    icon: CreditCard,
    color: '#DE3C4B'
  },
  {
    id: 'savings',
    name: 'Build Savings',
    description: 'Emergency fund, big purchase, or vacation',
    icon: PiggyBank,
    color: '#2E86AB'
  }
];

export const WEEKS_OFF_OPTIONS = [
  { value: 0, label: 'No time off', description: 'Work all 52 weeks' },
  { value: 2, label: '2 weeks off', description: '50 working weeks' },
  { value: 4, label: '4 weeks off', description: '48 working weeks' },
  { value: 8, label: '8 weeks off', description: '44 working weeks' },
  { value: 12, label: '12 weeks off', description: '40 working weeks' },
  { value: 'custom', label: 'Custom', description: 'Set your own' }
];

// Self-employment tax rate (fixed)
export const SELF_EMPLOYMENT_TAX = 0.141; // Effective rate: 15.3% × 92.35% ≈ 14.1%
